module.exports = __webpack_public_path__ + "fonts/fa-solid-900.c65d154.ttf";